module.exports = __webpack_public_path__ + "static/key-strangebrigade-61723af67eaca2cda9d4601fcc79f7dd.webp";